import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/services/app.service';
import { SharedService } from 'src/app/services/shared.service';
import { AuthState, Logout } from 'src/app/states/auth.state';
import { Utility } from 'src/app/core/common';
import { PushService } from 'src/app/services/push.service';
import { ActivityService } from 'src/app/services/activity.service';
import { ChatService } from 'src/app/services/chat.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-flex-layout',
	templateUrl: './flex-layout.component.html',
	styleUrls: ['./flex-layout.component.scss']
})
export class FlexLayoutComponent implements OnInit, OnDestroy {
	Utility = Utility;
	menuOpen = false;
	expandedMenu = false;
	isMobile = false;
	profileOpen = false;
	homepage = false;
	noScroll = false;
	user: any;
	newVersion: boolean;
	panel: string;
	fluid: boolean;
	hideBanner: boolean;
	showNotificationPanel = false;
	showSupport: boolean;
	token : string;
	labsUrl= environment.app.labsUrl;
	public static events = {
		notificationPanel: 'notification-panel:show'
	};
	ChatService = ChatService;

	constructor(public sharedService: SharedService, public appService: AppService, public pushService: PushService,
		public activityService: ActivityService, private store: Store, public chatService: ChatService,
		private authService: AuthService, private breakpointObserver: BreakpointObserver) {
		sharedService.onEventBus(FlexLayoutComponent.events.notificationPanel, () => this.openNotificationPanel(), this.unsubscribe$);
		// sharedService.activatedRoute$.subscribe(route => this.showSupport = route.component != ChatComponent);
	}

	async ngOnInit() {
		this.isMobile = this.breakpointObserver.isMatched('(max-width: 767.98px)');
		this.homepage = this.sharedService.getRouteData('homepage');
		this.panel = this.sharedService.getRouteData('panel');
		this.fluid = this.sharedService.getRouteData('fluid');
		this.hideBanner = this.sharedService.getRouteData('hideBanner');
		this.noScroll = this.sharedService.getRouteData('noScroll');
		this.expandedMenu = !this.isMobile && this.sharedService.getRouteData('expandedMenu');
		this.menuOpen = this.expandedMenu;
		this.breakpointObserver.observe('(max-width: 767.98px)')
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(state => {
				if (this.isMobile === state.matches) return;
				this.isMobile = state.matches;
				this.expandedMenu = !this.isMobile && this.sharedService.getRouteData('expandedMenu');
				this.menuOpen = this.expandedMenu;
			});
		this.token = this.store.selectSnapshot<string>(state => state.auth.token);


		this.sharedService.navigationEnd$
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(() => {
				this.homepage = this.sharedService.getRouteData('homepage');
				this.noScroll = this.sharedService.getRouteData('noScroll');
				this.expandedMenu = !this.isMobile && this.sharedService.getRouteData('expandedMenu');
			});

		if (this.sharedService.isBrowser) {
			AuthState.user$
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe(async user => {
					this.user = user;
				});

			this.appService.newVersion$
				.pipe(takeUntil(this.unsubscribe$))
				.subscribe(newVersion => this.newVersion = <boolean>newVersion);
		}
	}

	private unsubscribe$ = new Subject<void>();
	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	async logout() { await this.store.dispatch(Logout); }

	reload() {
		this.appService.update();
	}

	async requestNotificationPermission() {
		if (await this.pushService.requestPermission())
			delete this.showNotificationPanel;
	}

	async openNotificationPanel() {
		this.showNotificationPanel = true;
		await this.loadMessages();
		if (!this.user?.HasOverduePush)
			await this.pushService.setIsRead();
	}
	messages: any[];
	async loadMessages() {
		if (!this.user) return;

		this.messages = await this.pushService.getMessages();
	}
}
